import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ButtonNormal from '../Buttons/ButtonNormal';
import axios from 'axios';

const StyledTableCell = withStyles({
  head: {
    backgroundColor: 'white',
    color: '#484848',
    fontWeight: 'bold',
    borderBottom: '0.5px solid #c1c1c1',
    '&:first-child': {
      paddingLeft: 16,
    },
    '&:last-child': {
      paddingRight: 16,
    },
  },
  body: {
    fontSize: 14,
    fontWeight: (props) => (props.fontWeight ? props.fontWeight : 'normal'),
    color: (props) => (props.color ? props.color : '#484848'),
    fontStyle: (props) => (props.fontStyle ? props.fontStyle : 'normal'),
    borderBottom: 'none',
    '&:first-child': {
      paddingLeft: 16,
    },
    '&:last-child': {
      paddingRight: 16,
    },
  },
})(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: '#f5f5f5',
    },
  },
}))(TableRow);

const bills = [
  {
    factura: 'Enero',
    total: '$1,399.00',
    pdfLink: '123456789A',
    xmlLink: 'qeqweqw',
    date: '13/01/2020',
    concepto: 'Pago de membresía',
  },
  {
    factura: 'Febrero',
    total: '$1,399.00',
    pdfLink: '123456789B',
    xmlLink: 'qeqweqw',
    date: '13/01/2020',
    concepto: 'Pago de membresía',
  },
  {
    factura: 'Marzo',
    total: '$1,399.00',
    pdfLink: '123456789420',
    xmlLink: 'qeqweqw',
    date: '13/01/2020',
    concepto: 'Pago de membresía',
  },
];

const useStyles = makeStyles({
  tableContainer: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 700,
  },
  download: {
    color: '#10587f',
    textDecoration: 'none',
    cursor: 'pointer',
  },

});

function currencyFormat(num) {
  return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const BillingTable = ({handleSendInvoice, invoicesData}) => {
  const classes = useStyles();

   /* Format amount */

  return (
    <div style={{ maxWidth: 880, margin: '0 auto' }}>
      <TableContainer
        component={Paper}
        classes={{ root: classes.tableContainer }}
      >
        <Table className={classes.table} aria-label="customized table" padding="default">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                Factura
              </StyledTableCell>
              <StyledTableCell>Concepto</StyledTableCell>
              <StyledTableCell>Fecha</StyledTableCell>
              <StyledTableCell>Total</StyledTableCell>

              <StyledTableCell>PDF/XML</StyledTableCell>
              <StyledTableCell component="div" >Email</StyledTableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {invoicesData && invoicesData.data && invoicesData.data.map((row, index) => (
              <StyledTableRow key={index}>

                <StyledTableCell component="div">
                  {row.id}

                </StyledTableCell>
                <StyledTableCell >{currencyFormat(row.items[0].product.price)}</StyledTableCell>
                <StyledTableCell>{row.created_at.slice(0, 10)}</StyledTableCell>
                <StyledTableCell>{currencyFormat(row.total)}</StyledTableCell>
                <StyledTableCell>
                  <a href={`${process.env.REACT_APP_FIREBASE_URLSERVICE}/invoices/download_zip?idInvoice=${row.id}`} download="invoce" className={classes.download}>Descargar</a>
                </StyledTableCell>
                <StyledTableCell>
                   <div onClick={() => handleSendInvoice(row.id)} className={classes.download}>Enviar</div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </div>
  );
};

export default BillingTable;
